import { Loading01 } from "@untitledui/icons";
import type { SelectAllState } from "@/hooks/use-select-all-across-pages";
import { cx } from "@/utils/cx";

export const SelectAllPagesButton = ({ state, className }: { state: SelectAllState; className?: string }) => {
  if (!state.showSelectAll && !state.isFetching) return null;

  return (
    <>
      <button
        type="button"
        className={cx("text-sm font-medium underline", className)}
        onClick={state.selectAll}
        disabled={state.isFetching}
      >
        Select all {state.total.toLocaleString()}
      </button>
      {state.isFetching && (
        <span className="flex items-center gap-1 text-sm">
          <Loading01 className="w-4 h-4 animate-spin" />
          {state.progress.total !== null &&
            `${state.progress.loaded.toLocaleString()} / ${state.progress.total.toLocaleString()}`}
        </span>
      )}
    </>
  );
};
